/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData
 */
export interface FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData
     */
    OriginUrl: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData(value: object): value is FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData {
    if (!('OriginUrl' in value) || value['OriginUrl'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthDataFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthDataFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData {
    if (json == null) {
        return json;
    }
    return {
        
        'OriginUrl': json['OriginUrl'],
    };
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthDataToJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthDataToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthDataToJSONTyped(value?: FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'OriginUrl': value['OriginUrl'],
    };
}

